import React, { type ReactNode } from 'react';
import { css, useTheme } from '@emotion/react';
import styled from 'types/theme.types';
import env0Logo from 'assets/images/envzero_logo_black_rgb.svg';
import envZeroFullBlack from 'assets/images/env-zero-full-black.svg';
import envZeroFullWhite from 'assets/images/env-zero-full-white.svg';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';

export interface InvitationLayoutProps {
  children?: ReactNode;
}

// The rebranded wordmark is a file swap rather than a recolour, and the black/white pair swaps by
// colour mode exactly like topbar-view.tsx's Sign pair - the Logo page ships one mark per background.
// The legacy arm keeps the old asset and its absolute offset untouched.
const InvitationLayout: React.FunctionComponent<InvitationLayoutProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Container>
      <LogoContainer>
        <img
          width="180px"
          src={theme.isNewDesign ? (theme.mode === 'dark' ? envZeroFullWhite : envZeroFullBlack) : env0Logo}
          alt={theme.isNewDesign ? 'env zero' : 'env0-logo'}
        />
      </LogoContainer>
      {children}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  ${legacyOnly(
    theme => css`
      background-color: ${theme.primaryGray};
    `
  )}

  ${newDesignOnly(css`
    background-color: var(--surface-main-page);
  `)}

  display: flex;
  align-items: center;
  justify-content: center;
`;

// The legacy offset hardcodes half the logo width; the new design centres it with a transform so the
// asset's own width stops being a magic number.
const LogoContainer = styled.div`
  position: absolute;
  top: 80px;

  ${legacyOnly(css`
    left: calc(50% - 90px);
  `)}

  ${newDesignOnly(css`
    left: 50%;
    transform: translateX(-50%);
  `)}
`;

export default InvitationLayout;
